'use client'

import { BgSvg, Asterisk, Ray, ErrorOutline } from './components'

interface IProps {
  onClick?: () => void
}
export const Error503 = ({ onClick }: IProps) => {
  return (
    <div className="relative flex mx-auto pt-20 justify-center w-full h-full bg-cover bg-center">
      <div className="absolute top-0">
        <BgSvg />
      </div>
      <div className="absolute top-6 -left-5 md:top-20 md:left-20">
        <Asterisk />
      </div>
      <div className="absolute bottom-[130px] right-6 md:bottom-[219px] md:right-16">
        <Ray />
      </div>
      <div className="flex flex-col items-center gap-6 z-10 ">
        <div className="flex items-center justify-center bg-overlay-dark rounded-full w-[84px] h-[84px]">
          <ErrorOutline />
        </div>
        <div className="text-notif-yellow text-xs font-extrabold uppercase flex items-center justify-center rounded-full bg-notif-yellow-01 px-4 py-1 h-8">
          Error 503
        </div>
        <p className="text-[40px] font-medium">Hubo un error</p>
        <p className="text-secondary text-base">
          Por favor, intenta recargando la página.
        </p>
        <button
          type="button"
          onClick={() => (onClick ? onClick() : window.location.reload())}
          className="flex bg-button-primary hover:bg-button-primary-hover active:bg-button-primary-pressed w-[150px] h-[52px] text-white font-semibold items-center justify-center py-[14px] px-6 rounded-full"
        >
          Recargar
        </button>
      </div>
    </div>
  )
}

export default Error503
